import React from "react";

const SingleYoutube = ({ item, setActiveVideo }) => {
  const { name, duration, banner, link } = item;
  return (
    <div
      onClick={() => setActiveVideo(link)}
      className="flex items-center gap-4 justify-between bg-black/40 p-2 
      cursor-pointer hover:opacity-80">
      <div>
        <p className="text-sm line-clamp-2">{name}</p>
        <p className="text-xs text-gray-400 pt-4">Duration :{duration}</p>
      </div>
      <img
        className="w-[6rem] h-[6rem] object-cover border border-gray-500"
        src={banner}
        alt="banner"
      />
    </div>
  );
};

export default SingleYoutube;
